export default __webpack_public_path__ + "static/media/Main_Propoller_Parallel.5ef6978b.png";